<template>
    <div>
        <button v-if="data.item.action_card_management==1" class="flat-button position-relative" @mouseover="hoverCancelButton=true" @mouseleave="hoverCancelButton=false" @click="cancelCard()">
            <div class="tooltip-button" v-if="hoverCancelButton">Cancel Card</div>
            <img :src="`${publicPath}/img/rcp/icon/cancel.png`" width="30px">
        </button>
        <button 
          v-if="data.item.action_card_management==1" 
          class="flat-button position-relative" 
          @mouseover="hoverChangePinButton=true" 
          @mouseleave="hoverChangePinButton=false" 
          @click="changePin()">
            <div class="tooltip-button" v-if="hoverChangePinButton">Change ATM PIN</div>
            <img :src="`${publicPath}/img/rcp/icon/change_pin.png`" width="30px">
        </button>
        <button v-if="data.item.action_card_management==1 || data.item.action_card_management==4" class="flat-button position-relative" @mouseover="hoverLockButton=true" @mouseleave="hoverLockButton=false" @click="lockUnlock()">
            <div class="tooltip-button" v-if="hoverLockButton">{{ data.item.action_card_management==1?'Lock Card':'Unlock Card' }}</div>
            <img :src="`${publicPath}/img/rcp/icon/${data.item.action_card_management==1?'lock':'unlock'}.png`" width="30px">
        </button>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        hoverChangePinButton:false,
        hoverCancelButton:false,
        hoverLockButton:false
      }
    },
    props: ['data'],
    methods:{
      changePin(){
        const card_number = this.data.item.card_number;
        this.$router.push({ name: 'change-atm-pin',params: { card_number }});
      },
      cancelCard(){
        this.$emit('do-cancel',this.data.item.card_number);
      },
      lockUnlock(){
        this.$emit('lock-unlock',{card_number:this.data.item.card_number,status:this.data.item.action_card_management});
      }
    }
  }
</script>